import { render, staticRenderFns } from "./ButtonImprint.vue?vue&type=template&id=2dd3cb4c&scoped=true&"
import script from "./ButtonImprint.vue?vue&type=script&lang=js&"
export * from "./ButtonImprint.vue?vue&type=script&lang=js&"
import style0 from "./ButtonImprint.vue?vue&type=style&index=0&id=2dd3cb4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd3cb4c",
  null
  
)

export default component.exports